<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre9 sgc-51">Maps</h1>
<p class="calibre1 dot1000"></p>
<p class="sgc-07">France, 1918</p>
<p class="sgc-77">The Somme, August–November 1918</p>
<p class="sgc-77">Exercise C-7, Tennessee Maneuvers, 16–17 June 1941</p>
<p class="sgc-77">Exercise C-8, Tennessee Maneuvers, 19–20 June 1941</p>
<p class="sgc-77">Exercise C-9, Tennessee Maneuvers, 23 June 1941</p>
<p class="sgc-77">Exercise C-10, Tennessee Maneuvers, 26 June 1941</p>
<p class="sgc-77">Field Maneuver #3, Louisiana Maneuvers, 5–7 September 1941</p>
<p class="sgc-77">Field Maneuver #4, Louisiana Maneuvers, 7–9 September 1941</p>
<p class="sgc-77">Field Maneuver #5, Louisiana Maneuvers, 15–19 September 1941</p>
<p class="sgc-77">Field Maneuver #5, Counterattack, Louisiana Maneuvers, 19 September 1941</p>
<p class="sgc-77">Field Maneuver #6, Louisiana Maneuvers, 23–28 September 1941</p>
<p class="sgc-77">Exercise #1, Carolina Maneuvers, 5–6 November 1941</p>
<p class="sgc-77">Exercise #2, Carolina Maneuvers, 7 November 1941</p>
<p class="sgc-77">Exercise #3, Part 1, Carolina Maneuvers, 16–17 November 1941</p>
<p class="sgc-77">Exercise #4, Carolina Maneuvers, 25–28 November 1941</p>
<p class="sgc-77">North Africa, November 1942–June 1943</p>
<p class="sgc-77">Sicily, July–November 1943</p>
<p class="sgc-77">Normandy, June–August 1944 (A)</p>
<p class="sgc-77">Normandy, June–August 1944 (B)</p>
<p class="sgc-77">Northwestern France, August–September 1944</p>
<p class="sgc-77">Belgium, September–October 1944</p>
<p class="sgc-77">Aachen, September–December 1944</p>
<p class="sgc-77">Battle of the Bulge, December 1944–January 1945</p>
<p class="sgc-77">Ruhr Valley Campaign, February 1945</p>
<p class="sgc-77">North German Plain, March 1945</p>
<p class="sgc-77">Drive to the Elbe, March–April 1945</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ListofMaps.vue?d7b97ed4